import { FilterState } from '@/components/FilterManager/types';

import { GroupedOptions, NewFilterOption, UseFilterValuesType } from '../types';

type GetUseFilterValuesType = (props: {
  filter: FilterState;
  filterId: string;
  groups: GroupedOptions[];
}) => UseFilterValuesType;

export const getUseFilterValues: GetUseFilterValuesType = ({ filter, filterId, groups }) => {
  const selectedFilterIds = filter[filterId] || [];
  const selectedOptions: NewFilterOption[] = (() => {
    const temp: NewFilterOption[] = [];
    groups.forEach((group) => {
      group.options.forEach((item) => {
        if (Array.isArray(selectedFilterIds) && selectedFilterIds.includes(item.value)) {
          temp.push(item);
        }
      });
    });
    return temp;
  })();

  const resolvedValue = selectedOptions.map((item) => item.label);

  return () => {
    return {
      selectedOptions,
      fetching: false,
      resolvedValue,
    };
  };
};
